/*
 * @Author: 曹小丽
 * @Description:
 * @Date: 2022-03-11 17:56:03
 * @LastEditTime: 2022-03-28 10:15:32
 * @FilePath: \insurforce-backstage-platform-side\src\views\customer\roleManage\request.js
 */
import request from '@/utils/request';

/**
 * @description 角色table表获取
 * @returns {Array}
 */

export function getRoleTable(data) {
  return request.post('admin/customer/role/list', data);
}

/**
 * @description 删除当前角色
 * @param {string}  id
 * @returns {}
 */

export function deleteRoleTable(data) {
  return request.post('admin/customer/role/delete', data);
}

/**
 * @description 修改角色
 * @param {string}  id
 * @param {string}  role
 * @param {string}  text
 * @returns {}
 */

export function editRole(data) {
  return request.post('admin/customer/role/edit', data);
}

/**
 * @description 新增
 * @param {string}  role
 * @param {string}  text
 * @returns {}
 */

export function addRole(data) {
  return request.post('admin/customer/role/store', data);
}

/**
 * @description 修改状态
 * @param {string}  role
 * @param {string}  status
 * @returns {}
 */

export function roleStatus(data) {
  return request.post('admin/customer/role/status', data);
}

/**
 * @description 角色资源
 * @param {string}  userId
 * @param {string}  status
 * @returns {}
 */

//  export function  roleResource(data) {
//   return request.post('admin/role/resource', data);
// }

/**
 * @description 配置数据权限列表
 * @param {number}  roleId
 * @param {number}  customerId
 */

export function roleMyConfig(data) {
  return request.post('admin/customer/role/myConfig', data);
}

/**
 * @description 配置数据权限添加新增
 * @param {number}  roleId
 * @param {string}  permissionsData
 * @param {number}  type
 * @param {object}  config
 */

export function roleConfigStore(data) {
  return request.post('admin/customer/role/configStore', data);
}

/**
 * @description 配置数据权限列表-详情
 * @param {number}  roleId
 * @param {number}  permissionsId
 * @param {number}  customerId
 */

export function roleConfigDataStore(data) {
  return request.post('admin/customer/role/configDataStore', data);
}

/**
 * @description 配置数据权限-下拉框
 * @param {string}  type
 */

export function getAgencyDataRoleInfo(data) {
  return request.post('admin/agency/get-agency-data-role-info', data);
}

/**
 * @description 获取单个架构组织名称
 * @param {string}  customerId
 * @param {string}  structureId
 */

export function getTreeName(data) {
  return request.post('admin/customer/user/getTreeName', data);
}

/**
 * @description 获取应用下拉列表
 * @param {string}  customerId
 * @param {string}  tag
 */

export function getApplication(data) {
  return request.post('admin/application/resource', data);
}

/**
 * @description 获取中介下拉列表
 * @param {string}  customerId
 * @param {string}  tag
 * @param {string}  type
 */

export function getIntermediary(data) {
  return request.post('admin/intermediary/resource', data);
}

/**
 * @description 获取客户下拉列表
 * @param {string}  customerId
 * @param {string}  tag
 * @param {string}  isLicense  牌照归属
 * @param {string}  isAll 是否获取全部数据
 */

export function getCustomer(data) {
  return request.post('admin/customer/resource', data);
}